export default __webpack_public_path__ + "static/media/adfcontrol.5591a1fc.gif";